@if (type === 'list' && !href) {
  <button class="dropdown__list-item" [ngClass]="{ 'dropdown__list-item--active': active }" type="button" (click)="click()">
    <ng-container *ngTemplateOutlet="singleItem"></ng-container>
  </button>
} @else if (type === 'list' && href) {
  <a [href]="href" class="dropdown__list-item" [ngClass]="{ 'dropdown__list-item--active': active }" (click)="linkClick($event)">
    <ng-container *ngTemplateOutlet="singleItem"></ng-container>
  </a>
} @else if (type === 'checkbox' || type === 'radio') {
  <app-checkbox class="dropdown__list-item" [ngClass]="{ 'dropdown__list-item--active': active }" [(active)]="active" [name]="name" [type]="type" (activeChange)="click()">
    <span class="dropdown__list-item-left">
      @if (href) {
        <a class="dropdown__list-item-link" [href]="href" (click)="linkClick($event)"><ng-container *ngTemplateOutlet="content"></ng-container></a>
      } @else {
        <ng-container *ngTemplateOutlet="content"></ng-container>
      }
      @if (count) {
        <app-sticker [color]="active ? 'primary' : 'default'">{{ count }}</app-sticker>
      }
    </span>
  </app-checkbox>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #singleItem>
  <div class="dropdown__list-item-content">
    <span class="dropdown__list-item-left">
      <ng-container *ngTemplateOutlet="content"></ng-container>
      @if (count) {
        <app-sticker [color]="active ? 'primary' : 'default'">{{ count }}</app-sticker>
      }
      @if (active && type === 'list') {
        <app-icon [icon]="'check'" [height]="10"></app-icon>
      }
    </span>
    @if (type === 'list') {
      <app-icon class="dropdown__list-item-chevron" [icon]="'chevron'" [height]="16"></app-icon>
    }
  </div>
</ng-template>
